import { useEffect, useState } from "react";
import { Users2, Check } from "lucide-react";
import api from "@/lib/api";

// Shared Internal Team Members picker used wherever a Meeting activity is created/edited
// (Schedule Meeting modal, generic activity popup, lead drawer, stage-change popup).
export default function MeetingTeamMembers({ value = [], onChange }) {
  const [teamUsers, setTeamUsers] = useState([]);

  useEffect(() => {
    api.get("/activities/team-members").then(({ data }) => setTeamUsers(data.data || [])).catch(() => {});
  }, []);

  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);

  return (
    <div data-testid="meeting-team-members">
      <label className="mb-1 flex items-center gap-1.5 text-sm font-medium text-ink/80"><Users2 className="h-4 w-4 text-loop" />Internal Team Members</label>
      <p className="mb-1.5 text-xs text-ink/50">Add seniors, managers, or team members who should join this meeting.</p>
      <div className="flex max-h-32 flex-wrap gap-1.5 overflow-y-auto rounded-lg border border-sky p-2">
        {teamUsers.length === 0 ? (
          <span className="px-1 py-1 text-xs text-ink/40">No internal users available.</span>
        ) : teamUsers.map((u) => {
          const on = value.includes(u.id);
          return (
            <button key={u.id} type="button" data-testid={`team-member-${u.id}`} onClick={() => toggle(u.id)}
              className={`flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-medium transition-colors ${on ? "border-loop bg-loop text-white" : "border-sky text-ink/70 hover:border-loop hover:text-loop"}`}>
              {on && <Check className="h-3 w-3" />}{u.name}
            </button>
          );
        })}
      </div>
      {value.length > 0 && <p className="mt-1 text-[11px] text-ink/50">{value.length} member{value.length > 1 ? "s" : ""} will be added.</p>}
    </div>
  );
}
